import React, { useContext } from "react";

import NotificationsDropdown from "../notifications-dropdown";
import MessagesDropdown from "../messages-dropdown";
import UserInfoDropdown from "../user-info-dropdown";

import { MenuContext } from "../../providers/menu";

const Navbar = () => {
  const { clickMenuOpen } = useContext(MenuContext);
  return (
    <nav className="navbar navbar-default navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">
      {/* <!-- Sidebar Toggle (Topbar) --> */}
      <button
        onClick={clickMenuOpen}
        id="sidebarToggle"
        className="bg-primary text-white rounded-circle border-0"
      >
        <i className="fa fa-bars"></i>
      </button>

      {/* <!-- Topbar Navbar --> */}
      <ul className="navbar-nav ml-auto">
        <NotificationsDropdown />
        <MessagesDropdown />
        <div className="topbar-divider d-none d-sm-block"></div>
        <UserInfoDropdown />
      </ul>
    </nav>
  );
};

export default Navbar;
